import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
// Observable class extensions
import 'rxjs/add/observable/of';
// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';

import { PocService } from '../../../services/index';

@Component({
	selector: 'add-edit-testing-types-window',
	templateUrl: './addEditPoc.component.html'
})
export class AddEditPocComponent implements OnInit {
	public title: string;
	public mode: string;
	public list: any[] = [];
	public pocdata: any[] = [];

	// trigger-variable for Ladda
	isLoading: boolean = false;
	subscribeAuth;
	subscribeBranch;
	@Output() pocLoadEvent = new EventEmitter();

	povList = ['Testing', 'Trial', 'Therapy', 'Programing', 'Re-Programing', 'Re-Check up', 'Re-Trial', 'Fitting', 'Mould', 'OCT', 'Assessment', 'Cleaning'];
	statusList = ['Active', 'Inactive'];
	referenceList = [];
	branchList: any[] = [];
	povCtrl: FormControl;
	statusCtrl: FormControl;
	referenceCtrl: FormControl;
	branchCtrl: FormControl;
	filteredReference: Observable<any[]>;
	filteredBranch: Observable<any[]>;
	usertype = '';

	constructor(
		public store: Store<fromRootStore.State>,
		private pocService: PocService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService) {
		this.povCtrl = new FormControl('', [
			Validators.required
		]);
		this.statusCtrl = new FormControl('', [
			Validators.required
		]);
		this.referenceCtrl = new FormControl('', [
			Validators.required
		]);
		this.filteredReference = this.referenceCtrl.valueChanges
			.startWith(null)
			.map(name => name ? this.filterItems(name) : this.referenceList.slice());
		this.branchCtrl = new FormControl();
		this.filteredBranch = this.branchCtrl.valueChanges
			.startWith(null)
			.map(name => name ? this.filterBranch(name) : this.branchList.slice());
	}

	ngOnInit(): void {
		let that = this;
		//TO LOAD REFERENCE COMBO LIST

		this.store.select(fromCommonStore.getAllReference).subscribe((res: any) => {
			if (_.isEmpty(res)) {
				return;
			}
			this.referenceList = res;
			that.referenceCtrl.setValue(that.pocdata['reference_id']);
		});
		//To LOAD BRANCH LIST
		this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
			if (_.isEmpty(res.data)) {
				return;
			}
			this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
			that.branchCtrl.setValue(that.pocdata['branch_id']);
		});

		this.subscribeAuth = this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
			if (auth['islogin']) {
				that.usertype = auth['usertype'];
				if (auth['usertype'] != 'Super_Admin' && auth['usertype'] != 'Admin' && auth['usertype'] != 'Accounts') {
					that.pocdata['branch_id'] = auth['branch_id'];
					that.branchCtrl.disable();
				}

			}
		});

		setTimeout(() => {
			$('#test_type_name').focus();
		}, 100);
	}

	filterBranch(name: string) {
		name = _.escapeRegExp(name);
		return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
	}
	displayBranch(branch_id: any) {
		if (this.branchList != undefined) {
			if (branch_id && this.branchList.length > 0) {
				let fitem = this.branchList.find(data => data.branch_id == branch_id);
				return fitem && fitem['branch_name'] ? fitem['branch_name'] : '';
			}
		}
		return '';
	}

	filterItems(name: string) {
		name = _.escapeRegExp(name);
		return this.referenceList.filter(item => (new RegExp(name, 'gi').test(item.client_code) || new RegExp(name, 'gi').test(item.name)));
	}

	displayRef(ref_id: number) {
		if (ref_id && this.referenceList.length > 0) {
			let fitem = this.referenceList.find(data => data.ref_id == ref_id);
			return fitem && fitem['name'] ? fitem['name'] : '';

			// let fitem = _.find(this.referenceList, { 'ref_id': ref_id }),
			//     ref_name = fitem.name;
			//     this.pocdata['ref_name'] = ref_name;
			// return fitem['name'];
		}
		return '';
	}

	onEnterKeyPressed(nextEl: string): void {
		$('#' + nextEl).focus();
	}

	ngOnDestroy() {
		// prevent memory leak when component destroyed
		//this.subscribeService.publishReloadClientWalkInGrid().unsubscribe();
		if (!_.isEmpty(this.subscribeAuth)) {
			this.subscribeAuth.unsubscribe();
		}
	}

	onSavePoc(): void {
		let that = this;
		this.isLoading = true;
		this.pocdata['fees'] = this.pocdata['fees'] ? this.pocdata['fees'] : 0;
		this.pocService
			.addUpdatePoc(this.pocdata)
			.then(function (res: any) {
				that.isLoading = false;
				if (res.success) {
					swal('SUCCESS', res.message, 'success');
					that.bsModalRef.hide();
					that.pocLoadEvent.emit();
				} else {
					var toast = {
						type: 'error',
						title: 'ERROR',
						body: res.message
					};
					that.toasterService.pop(toast);
				}
			});
	}
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/poc/addEditPoc.component.ts